import {Component, DoCheck, Input, OnInit} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {ExgModalService} from 'exc-controls-v2';
import {ApplicationService} from '../../services/application.service';
import {EnumerationService} from '../../services/enumeration.service';
import {ExcFileItem} from 'exc-upload-v2';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-modal-oe-formular-template',
  templateUrl: './modal-oe-formular-template.component.html',
  styles: [
  ]
})
export class ModalOEFormularTemplateComponent extends ExcTranslation implements OnInit, DoCheck {
  @Input() data: any;

  dataModel: any = {
    frmTName: '',
    frmTDescription: '',
    frmT_aue_enmIdent_Versicherungsart: -1,
    frmT_enmIdent_DokTyp: null,
    frmTIsDraft: true
  };
  dataModelClone: any;
  isNew = true;
  isDisabled = false;
  dokTypList = [] as any[];

  selectedFiles: ExcFileItem[] = [];
  acceptedFileTypes = ['PDF', 'DOCX', 'XLSX', 'JPEG', 'PNG'];

  files = {
    selection: [],
  };

  private _MAXFILESIZE = environment.rest.MAXFILESIZE;
  get MAXFILESIZE(): number {
    return this._MAXFILESIZE;
  }

  constructor(
    private modalSvc: ExgModalService,
    public appSvc: ApplicationService,
    public enumSvc: EnumerationService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.dokTypList = this.getDokTypList();

    if (!this.data) {
      this.dataModelClone = this.appSvc.helperObj.clone(this.dataModel);
      this.isNew = true;
    } else {
      this.dataModelClone = this.appSvc.helperObj.clone(this.data);
      this.dataModel = this.appSvc.helperObj.clone(this.data);
      this.isNew = false;
    }
  }

  ngDoCheck(): void {
    if (this.appSvc.helperObj.changed(this.dataModel, this.dataModelClone)) {
      if (this.dataModelClone.frmTName
        && this.dataModelClone.frmTName.length > 0
        && this.dataModelClone.frmT_enmIdent_DokTyp
        && ((this.isNew && this.getFiles().length === 1) || !this.isNew)
      ) {
        this.isDisabled = false;
      }
    } else {
      this.isDisabled = true;
    }
  }

  getDokTypList(): any[] {
    const list = this.enumSvc.getEnumerationList('DokTyp');

    return list.filter((e, i) => list.findIndex(x => x.enmIdent === e.enmIdent) === i);
  }

  onFilesSelect(files: ExcFileItem): void {
    this.selectedFiles = this.selectedFiles.concat(files);
  }

  deleteFile(index: any): void {
    this.selectedFiles = this.selectedFiles.filter(file => file !== index);
  }

  isValidPDF(fileSize: number, fileExtension: string): boolean {
    return this.proofFileSize(fileSize) && this.acceptedFileTypes.includes(fileExtension.toUpperCase());
  }

  proofFileSize(size: number): boolean {
    return size < this.MAXFILESIZE;
  }

  getFiles(): any[] {
    const files = this.selectedFiles.filter((file: any) => this.isValidPDF(file.size, file.extension));
    if (!files) {
      return [];
    }
    return files;
  }

  delete(): void {
    this.modalSvc.action({
      frmTUPT: this.dataModelClone?.frmTUPT,
      frmTID: this.dataModelClone?.frmTID,
      del: true
    });
  }

  cancel(): void {
    this.close();
  }

  close(): void {
    this.modalSvc.close();
  }

  save(): void {
    if (this.appSvc.helperObj.changed(this.dataModel, this.dataModelClone)) {
      if (this.dataModelClone.frmTName && this.dataModelClone.frmTName.length > 0
        && this.dataModelClone.frmT_enmIdent_DokTyp) {
        if (this.isNew && this.getFiles().length === 1) {
          this.modalSvc.action({
            formData: ExcFileItem.getFormData(this.getFiles(), this.dataModelClone)
          });
        } else if (!this.isNew) {
          this.modalSvc.action(this.dataModelClone);
        }
      }
    }
  }
}
